import axios from 'axios'
import { BUSCAR_DAMDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarDamdfe(id, empresaId) {
  const url = `${URL}/emissao-mdfe/${id}/empresa/${empresaId}/damdfe`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_DAMDFE,
        payload: response
      })
  );
}
